import { EditPromo } from 'features/ManageCampaigns/EditPromoDialog'

const MainPromo = ({
  promotionCode,
  setPromotionCode,
  minNightsToStay,
  setMinNightsToStay,
  maxDiscountPercentage,
  setMaxDiscountPercentage,
  setPromoTagline,
  promoTagline,
  hasPromoValidityDate,
  setHasPromoValidityDate,
  promoValidityStartDate,
  setPromoValidityStartDate,
  promoValidityEndDate,
  setPromoValidityEndDate
}) => {
  return (
    <div>
      <EditPromo
        promoCode={promotionCode}
        setPromoCode={setPromotionCode}
        minNights={minNightsToStay}
        setMinNights={setMinNightsToStay}
        maxDiscount={maxDiscountPercentage}
        setMaxDiscount={setMaxDiscountPercentage}
        setPromoTagline={setPromoTagline}
        promoTagline={promoTagline}
        hasPromoValidityDateControls={true}
        hasPromoValidityDate={hasPromoValidityDate}
        setHasPromoValidityDate={setHasPromoValidityDate}
        promoValidityStartDate={promoValidityStartDate}
        setPromoValidityStartDate={setPromoValidityStartDate}
        promoValidityEndDate={promoValidityEndDate}
        setPromoValidityEndDate={setPromoValidityEndDate}
      />
    </div>
  )
}

export default MainPromo
